module.exports = __webpack_public_path__ + "img/monthly-report.f1db3256.jpg";